// i18n must be imported first to ensure it's initialized before routes
import "./i18n";
import { deriveReservedPartnerRouteSegmentsFromRouteTree } from "@pandas/core-ui/route";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { RouteErrorFallback } from "./components/RouteErrorFallback";
import { servicesOrchestratorValues } from "./config/services";
import { staleChunkRecovery } from "./lib/staleChunkRecovery";
import { routeTree } from "./routeTree.gen";

const reservedPartnerRouteSegments = deriveReservedPartnerRouteSegmentsFromRouteTree(routeTree);
staleChunkRecovery.startChunkPreloadRecovery();

const router = createRouter({
	routeTree,
	basepath: "/",
	trailingSlash: "never",
	defaultErrorComponent: RouteErrorFallback,
	context: {
		reservedPartnerRouteSegments,
	},
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const setInnerHeight = function () {
	const VH = window.innerHeight;
	document.documentElement.style.setProperty("--vh", `${VH}px`);
};

window.addEventListener("resize", setInnerHeight);
window.addEventListener("DOMContentLoaded", setInnerHeight);

if (window.location.protocol === "http:" && !servicesOrchestratorValues.isDevelopment)
	window.location.href = window.location.href.replace("http:", "https:");

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
	<StrictMode>
		<ErrorBoundary>
			<RouterProvider router={router} />
		</ErrorBoundary>
	</StrictMode>,
);
